/*
  Bong bong chat khong duoc che nut mua. (16/09/2026)

  Widget la <shopify-chat> cua app Shopify Inbox: position fixed, phu kin man hinh,
  z-index 2147483000, ruot nam trong shadow root DONG -> khong chen duoc gi vao trong.
  Nen dieu khien tu NGOAI: gan class len <html>, phan an/hien do CSS lo (base.css).

  Luat: nut Add to cart / Thanh toan dang nhin thay trong khung nhin -> an chat.
        Cuon qua, khong con nhin thay -> hien lai.
*/
(function () {
  var SEL = '.cstrap__add, button[name="add"], .product-form__submit, #checkout,'
          + ' [name="checkout"], .cart__checkout-button, .cart-drawer__checkout, #CartDrawer-Checkout,'
          /* 08/10 (chu shop): + nut cua popup gio va nut thanh mua dinh .cbar */
          + ' #cart-notification-button, .cart-notification [name="checkout"], .cbar__nut';
  var goc = document.documentElement;
  var muc = [];
  var cho = false;
  /* 08/10 20:47 (chu shop, muc C): trang builder (DYO / Rally builder / Bespoke / V2) — khoi FORM dang tren man hinh, hoac dang go
     trong form -> chat cung nhuong (an: opacity 0 + khong bam duoc, CSS base.css chi ap < 750px). Ra khoi form -> hien lai. */
  var FORM = '.cstrap-section form[id^="cstrap-form-"]';
  var dangGo = false;
  function formThay() { var ds = document.querySelectorAll(FORM); for (var i = 0; i < ds.length; i++) if (nhinThay(ds[i])) return true; return false; }

  // Nhin thay that: khong bi an, co kich thuoc, va nam trong khung nhin.
  // Phai kiem visibility vi ngan keo gio dong van giu nguyen o (Dawn dung visibility: hidden).
  function nhinThay(n) {
    if (!n.isConnected) return false;
    var s = getComputedStyle(n);
    if (s.visibility === 'hidden' || s.display === 'none' || s.opacity === '0') return false;
    var r = n.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    return r.bottom > 0 && r.top < (window.innerHeight || goc.clientHeight);
  }

  function danhGia() {
    cho = false;
    for (var i = muc.length - 1; i >= 0; i--) {
      if (!muc[i].isConnected) muc.splice(i, 1);
    }
    var co = false;
    for (var j = 0; j < muc.length; j++) {
      if (nhinThay(muc[j])) { co = true; break; }
    }
    if (!co && (dangGo || formThay())) co = true;
    goc.classList.toggle('chat-nhuong', co);
  }

  function hen() {
    if (cho) return;
    cho = true;
    requestAnimationFrame(danhGia);
  }

  var soi = ('IntersectionObserver' in window)
    ? new IntersectionObserver(hen, { threshold: 0 })
    : null;

  function gom() {
    var ds = document.querySelectorAll(SEL);
    for (var i = 0; i < ds.length; i++) {
      var n = ds[i];
      if (n.__chatTheoDoi) continue;
      n.__chatTheoDoi = 1;
      muc.push(n);
      if (soi) soi.observe(n);
    }
    hen();
  }

  gom();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gom);
  document.addEventListener('focusin', function (e) { if (e.target && e.target.closest && e.target.closest(FORM)) { dangGo = true; hen(); } });
  document.addEventListener('focusout', function () { setTimeout(function () { var a = document.activeElement; dangGo = !!(a && a.closest && a.closest(FORM)); hen(); }, 0); });
  addEventListener('scroll', hen, { passive: true });
  addEventListener('resize', hen);

  // Gio ve lai bang AJAX, ngan keo dong/mo -> nut Checkout la phan tu moi hoac doi trang thai.
  var doi = null;
  new MutationObserver(function () {
    clearTimeout(doi);
    doi = setTimeout(gom, 150);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
})();

/*
  08/10/2026 (chu shop) — THONG BAO GIO NAM TREN CUNG. Cart drawer, popup "Item added to your cart" va thanh mua
  dinh .cbar duoc dua len TOP LAYER bang Popover API (popover="manual" + showPopover / hidePopover) — top layer nam
  tren MOI z-index, ke ca <shopify-chat>. Thu tu trong top layer = thu tu mo: gio mo sau thanh -> gio nam tren thanh.
  Giao dien / vi tri / hieu ung / cach dong (X, bam ra ngoai, Esc) giu nguyen: theme van gan class (active / is-hien)
  nhu cu, file nay chi nghe class roi dua phan tu vao / ra top layer. Dong: doi het hieu ung (350 ms) roi moi rut ra.
  Popup "Item added to your cart" (cart-notification) KHONG dua vao top layer: shop dung cart drawer (cart_type = drawer) nen
  popup do khong hien; dua vao top layer se doi goc toa do (absolute -> theo man hinh). Nut cua no da vao SEL o tren.
  Trinh duyet khong co Popover API -> z-index 2147483647.
  CSS bu kieu mac dinh cua [popover] (vien, dem, inset...) o base.css (khoi 08/10). KHONG dung vao shopify-chat.
*/
(function () {
  var coPopover = typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('showPopover');
  var DS = [
    { sel: 'cart-drawer', mo: function (e) { return e.classList.contains('active'); } },
    { sel: '.cbar', mo: function (e) { return e.classList.contains('is-hien') && !e.hidden; } }
  ];

  function dangMo(e) { try { return e.matches(':popover-open'); } catch (x) { return false; } }

  function capNhat(e, d) {
    if (!coPopover) {
      e.style.zIndex = d.mo(e) ? '2147483647' : '';
      return;
    }
    if (d.mo(e)) {
      clearTimeout(e.__rutRa);
      if (!dangMo(e)) { try { e.showPopover(); } catch (x) {} }
    } else if (dangMo(e)) {
      clearTimeout(e.__rutRa);
      e.__rutRa = setTimeout(function () { if (!d.mo(e) && dangMo(e)) { try { e.hidePopover(); } catch (x) {} } }, 350);
    }
  }

  function gan() {
    DS.forEach(function (d) {
      document.querySelectorAll(d.sel).forEach(function (e) {
        if (e.__topLayer) return;
        e.__topLayer = 1;
        if (coPopover && !e.hasAttribute('popover')) e.setAttribute('popover', 'manual');
        new MutationObserver(function () { capNhat(e, d); }).observe(e, { attributes: true, attributeFilter: ['class', 'hidden'] });
        capNhat(e, d);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gan);
  else gan();
  /* .cbar do engine dung sau khi trang tai -> gan lai vai lan */
  var lan = 0;
  (function lai() { gan(); if (++lan < 20) setTimeout(lai, 500); })();
})();

/*
  08/10/2026 (chu shop, muc 6 S9) — CHECK OUT 1 CHAM. Cham -> chu "Going to checkout…" + vong xoay + khoa ngay (khong gui lan 2,
  khach khong tuong lag ma bam tiep). Quay lai trang bang nut Back (bfcache) -> mo khoa.
  KHONG prefetch /checkout: GET /checkout tao phien thanh toan that (lam lech so lieu "bat dau thanh toan").
*/
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
    if (!b) return;
    if (b.__dangDi) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    b.__dangDi = 1;
    if (b.__goc == null) b.__goc = b.innerHTML;
    b.setAttribute('aria-busy', 'true');
    setTimeout(function () { b.classList.add('is-dang-them'); b.innerHTML = '<span class="catc-quay" aria-hidden="true"></span>Going to checkout\u2026'; }, 0);
    setTimeout(function () { mo(b); }, 15000);   /* that bai im lang -> sau 15 s cho bam lai */
  }, true);
  function mo(b) { b.__dangDi = 0; b.removeAttribute('aria-busy'); b.classList.remove('is-dang-them'); if (b.__goc != null) { b.innerHTML = b.__goc; b.__goc = null; } }
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button').forEach(function (b) { if (b.__dangDi) mo(b); });
  });
})();
